<form [formGroup]="form" class="p-fluid" (ngSubmit)="onSave()">
  <div class="formgrid grid mb-3">

    <!-- User ID (Readonly) -->
    <div class="field col-12" *ngIf="form.get('id')?.value">
      <div class="p-float-label">
        <input pInputText id="id" formControlName="id" class="w-full" />
        <label for="id">{{ 'USER_ID' | translate }}</label>
      </div>
    </div>

    <!-- First Name and Last Name -->
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="firstName" formControlName="firstName" class="w-full" [readonly]="currentMode === 'read'" />
        <label for="firstName">{{ 'FIRST_NAME' | translate }}<span class="required-asterisk text-yellow-500">*</span></label>
      </div>
      <div *ngIf="form.get('firstName')?.invalid && form.get('firstName')?.touched" class="text-red-500 mb-2">
        <small>{{ 'FIRST_NAME_REQUIRED' | translate }}</small>
      </div>
    </div>
    <div class="field col-6">
      <div class="p-float-label">
        <input pInputText id="lastName" formControlName="lastName" class="w-full" [readonly]="currentMode === 'read'" />
        <label for="lastName">{{ 'LAST_NAME' | translate }}<span class="required-asterisk text-yellow-500">*</span></label>
      </div>
       <div *ngIf="form.get('lastName')?.invalid && form.get('lastName')?.touched" class="text-red-500 mb-2">
        <small>{{ 'LAST_NAME_REQUIRED' | translate }}</small>
      </div>
    </div>

    <!-- Email -->
    <div class="field col-12">
       <div class="p-float-label">
         <!-- Rely on form control's disabled state set in facade -->
        <input pInputText type="email" id="email" formControlName="email" class="w-full" />
        <label for="email">{{ 'EMAIL' | translate }}<span class="required-asterisk text-yellow-500">*</span></label>
      </div>
       <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched" class="text-red-500 mb-2">
         <small *ngIf="form.get('email')?.errors?.['required']">{{ 'EMAIL_REQUIRED' | translate }}</small>
         <small *ngIf="form.get('email')?.errors?.['email']">{{ 'INVALID_EMAIL_FORMAT' | translate }}</small>
       </div>
    </div>

    <!-- Password Fields (Create Mode Only) -->
    <ng-container *ngIf="currentMode === 'create' && form.contains('password') && form.contains('passwordRepeat')">
      <div class="field col-6">
        <div class="p-float-label">
          <input pInputText type="password" id="password" formControlName="password" class="w-full" />
          <label for="password">{{ 'PASSWORD' | translate }}<span class="required-asterisk text-yellow-500">*</span></label>
        </div>
        <div *ngIf="form.get('password')?.invalid && form.get('password')?.touched" class="text-red-500 mb-2">
          <small *ngIf="form.get('password')?.errors?.['required']">{{ 'PASSWORD_REQUIRED' | translate }}</small>
          <small *ngIf="form.get('password')?.errors?.['minlength']">{{ 'PASSWORD_MINLENGTH' | translate }}</small>
        </div>
      </div>
      <div class="field col-6">
        <div class="p-float-label">
          <input pInputText type="password" id="passwordRepeat" formControlName="passwordRepeat" class="w-full" />
          <label for="passwordRepeat">{{ 'REPEAT_PASSWORD' | translate }}<span class="required-asterisk text-yellow-500">*</span></label>
        </div>
        <div *ngIf="form.get('passwordRepeat')?.invalid && form.get('passwordRepeat')?.touched" class="text-red-500 mb-2">
           <small *ngIf="form.get('passwordRepeat')?.errors?.['required']">{{ 'REPEAT_PASSWORD_REQUIRED' | translate }}</small>
        </div>
         <!-- Mismatch Error (Form Level) -->
         <div *ngIf="form.errors?.['passwordMismatch'] && form.get('passwordRepeat')?.touched" class="text-red-500 mb-2">
           <small>{{ 'PASSWORDS_DO_NOT_MATCH' | translate }}</small>
         </div>
      </div>
    </ng-container>

     <!-- Org Admin Disclaimer (Create Mode Only) -->
     <div class="field col-12" *ngIf="currentMode === 'create' && roleContext === 'orgAdmin'">
        <p-messages severity="info">{{'ORG_ADMIN_DISCLAIMER' | translate}}</p-messages>
     </div>

    <!-- Consent Checkboxes: Only show if present in user data -->
    <!--
    <div class="field col-12" *ngIf="form.get('consentPresent')?.value">
      <div class="flex flex-column gap-2">
        <div *ngIf="form.get('consentPresent')?.value['MARKETING']">
          <p-checkbox inputId="marketingConsent" formControlName="marketingConsent" [binary]="true"></p-checkbox>
          <label for="marketingConsent" class="ml-2">{{ 'MARKETING_CONSENT' | translate }}</label>
        </div>
        <div *ngIf="form.get('consentPresent')?.value['DATA']">
          <p-checkbox inputId="dataConsent" formControlName="dataConsent" [binary]="true"></p-checkbox>
          <label for="dataConsent" class="ml-2">{{ 'DATA_CONSENT' | translate }}</label>
        </div>
        <div *ngIf="form.get('consentPresent')?.value['ANALYTICS']">
          <p-checkbox inputId="analyticsConsent" formControlName="analyticsConsent" [binary]="true"></p-checkbox>
          <label for="analyticsConsent" class="ml-2">{{ 'ANALYTICS_CONSENT' | translate }}</label>
        </div>
      </div>
    </div>
  -->

    <div class="col-12">
      <app-global-consent-form
        [enableDataConsent]="false"
      />
    </div>

    <!-- Action Buttons -->
    <div class="col-12"> <!-- Wrap buttons in col-12 for grid alignment -->
      <div class="flex justify-content-end gap-2 mt-4">
        <button
          *ngIf="currentMode !== 'read'"
          pButton
          type="button"
          [label]="'CANCEL' | translate"
          class="p-button-text"
          (click)="onCancel()">
        </button>
        <button
          *ngIf="currentMode !== 'read'"
          pButton
          type="submit"
          [label]="'SAVE' | translate"
          [disabled]="form.invalid">
        </button>
      </div>
    </div>

    <!-- Horizontal Line -->
    <div class="col-12" *ngIf="form.get('permissionIds')?.value?.length > 0">
      <hr class="my-3"> <!-- Added horizontal line -->
    </div>

    <!-- Permissions Display -->
    <div class="field col-12" *ngIf="form.get('permissionIds')?.value?.length > 0">
      <label class="block mb-4">
        <i class="pi pi-lock mr-2"></i>
        {{ 'PERMISSIONS' | translate }}
      </label>
      <div class="flex flex-column gap-2">
        <div *ngFor="let perm of form.get('permissionIds')?.value" class="flex align-items-center">
          <p-chip
            [label]="perm.permission.displayName + (perm.organisation ? ' (' + (perm.organisation.displayName || perm.organisation.legalName) + ')' : '')"
            styleClass="mr-2 p-disabled">
          </p-chip>
          <i class="pi pi-trash cursor-pointer" (click)="onDeletePermission(perm)" *ngIf="currentMode !== 'read'"></i>
        </div>
      </div>
    </div>

  </div>
</form>
